import { Module } from '../modules/module';
import { TypeModule } from '../../enums/type-module';
import { NameModule } from '../name-module';

export class ModuleQuiz extends Module {
    typeVision: number;
    access_group: string; // uid of the group that is allowed access to the module
    selected: boolean;
    visOnlyForLoggedUser?: boolean;
    imgQuiz: string;


    constructor(name: NameModule, icon: string, typeVision: number, eventId: string, order: number, visOnlyForLoggedUser?: boolean) {
        super(name, icon, TypeModule.QUIZ, eventId, order, false, false, false)
        this.typeVision = typeVision;
        this.access_group = null;
        this.selected = true;
        this.imgQuiz = "";

        if (visOnlyForLoggedUser === undefined) {
            this.visOnlyForLoggedUser = false;
        } else {
            this.visOnlyForLoggedUser = visOnlyForLoggedUser;
        }
    }
}
